export default "__VITE_ASSET__CVYOSbqB__"